import React from "react";
import {clampDividerThickness, parseDividerLabel} from "./printoutDividerOptions";

export interface DividerViewAttrs {
    color: string | null;
    label: string | null;
    thickness: number;
}

const DividerView = ({attrs}: {attrs: DividerViewAttrs}) => {
    const label = parseDividerLabel(attrs.label);
    const lineStyle = {
        height: `${clampDividerThickness(attrs.thickness)}px`,
        ...(attrs.color ? {backgroundColor: attrs.color} : {}),
    };

    if (!label) {
        return <div className="printout-divider-block-line" style={lineStyle}/>;
    }

    return (
        <div className="printout-divider-block-labeled">
            <div className="printout-divider-block-line" style={lineStyle}/>
            <span
                className="printout-divider-block-label"
                style={attrs.color ? {color: attrs.color} : undefined}
            >
                {label}
            </span>
            <div className="printout-divider-block-line" style={lineStyle}/>
        </div>
    );
};

export default DividerView;
